// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.epzLL{display:flex;flex-direction:column;margin:0 auto;padding:0 20px}@media(max-width: 991px){.epzLL{height:100%;margin:10px 0 0;overflow:scroll;-webkit-overflow-scrolling:touch;padding:0 30px}.epzLL .V_buL{font-size:17px}}.epzLL .V_buL{font-size:20px}.aNSBd{margin-top:15px}.FW61H{margin-top:20px}.Q98z0{font-size:15px;-webkit-transform:unset;transform:unset}@media(max-width: 767px){.Q98z0{font-size:12px}}.Q98z0[data-index=\"1\"]{left:unset !important;right:0}.m0OcV{margin:30px 0 20px}.LOHlR{margin-left:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rateContentWrapper": "epzLL",
	"rateContentHeadings": "V_buL",
	"questionTitle": "aNSBd",
	"questionsWrapper": "FW61H",
	"sliderMarkLabel": "Q98z0",
	"submitBtn": "m0OcV",
	"btnLoader": "LOHlR"
};
module.exports = ___CSS_LOADER_EXPORT___;
